import { Marker } from "react-map-gl";
import CustomMarker from "assets/svgs/map-marker.svg";

const PinMarker = ({ children, selected }) => {
  const baseClassNames =
    "transition origin-bottom duration-400 ease-out transform relative w-8 h-8 cursor-pointer z-10 -left-4 -top-10";

  return (
    <div
      className={
        selected
          ? `transform scale-125 text-red ${baseClassNames}`
          : baseClassNames
      }
    >
      <CustomMarker />
      <div
        className={
          selected
            ? "bg-red pin-count transform scale-100"
            : "bg-black pin-count"
        }
      >
        {children}
      </div>
    </div>
  );
};

const ClusterMarker = ({ onClick, children }) => (
  <div className="cursor-pointer cluster-marker" onClick={onClick}>
    {children}
  </div>
);

export function MapMarker({ marker, isCluster, caseCount, selected, onClick }) {
  const [longitude, latitude] = marker.geometry.coordinates;
  return (
    <Marker onClick={onClick} latitude={latitude} longitude={longitude}>
      {isCluster && <ClusterMarker>{caseCount}</ClusterMarker>}
      {!isCluster && (
        <PinMarker data={marker.properties} selected={selected}>
          {caseCount}
        </PinMarker>
      )}
    </Marker>
  );
}
